type WithholdingTaxAllocation = {
  commitmentId: string;
  totalCommitmentLcy: number;
  withholdingTaxExempt: boolean;
  investorName: string;
};

const calculateTaxAllocation = (
  withholdingTaxAllocations: Array<WithholdingTaxAllocation>,
  commitmentId: string,
  allocationPercentageDecimal: number,
  nonTaxExemptAllocationPercentage?: number,
) => {
  const isTaxExempt =
    withholdingTaxAllocations.find(
      (withholdingTax) => withholdingTax.commitmentId === commitmentId,
    )?.withholdingTaxExempt ?? false;

  const effectiveTaxAllocationPercentage =
    isTaxExempt || !nonTaxExemptAllocationPercentage
      ? 0
      : (allocationPercentageDecimal * 100) / nonTaxExemptAllocationPercentage;

  return {
    isTaxExempt,
    effectiveTaxAllocationPercentage,
  };
};

export default calculateTaxAllocation;
